export default __webpack_public_path__ + "static/media/Video.59bce674.mov";